import React, { Component } from 'react'
import { Pagination } from 'react-bootstrap';

class PaginationTemplate extends Component {


    componentDidMount() {
        this.handlePageItems()
    }

    handlePageItems = () => {
        let items = [];
        for (let number = 1; number <= this.props.totalPages; number++) {
            items.push(
                <Pagination.Item key={number} active={number === this.props.activePage} onClick={this.props.handlePageClick.bind(this, number)}>
                    {number}
                </Pagination.Item>
            )
        }
        return items;
    }

    render() {
        return (
            <div>
                <Pagination style={{ float: 'right' }}>
                    <Pagination.First disabled={1 === this.props.activePage || 0 === this.props.totalPages} onClick={this.props.handlePageFirst.bind(this)} />
                    <Pagination.Prev disabled={1 === this.props.activePage || 0 === this.props.totalPages} onClick={this.props.handlePagePrev.bind(this)} />
                    {this.handlePageItems()}
                    <Pagination.Next disabled={this.props.activePage === this.props.totalPages || 0 === this.props.totalPages} onClick={this.props.handlePageNext.bind(this)} />
                    <Pagination.Last disabled={this.props.activePage === this.props.totalPages || 0 === this.props.totalPages} onClick={this.props.handlePageLast.bind(this)} />
                </Pagination>
            </div>
        )
    }

}

export default PaginationTemplate;